import React from "react";
import { Alert, Link } from "@mui/material";

const DecommissionBanner = () => {
  return (
    <Alert
      severity="error"
      variant="standard"
      sx={{
        borderRadius: 0,
        color: '#8B0000',
        backgroundColor: '#FDECEA',
        py: 0.25,
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 600,
        fontSize: '0.78rem',
        '& .MuiAlert-icon': { py: 0, fontSize: '1.1rem', color: '#8B0000' },
        '& .MuiAlert-message': { py: 0.25, textAlign: 'center' },
      }}
    >
      The data shown on this website is no longer being refreshed. For the latest datasets and reports, please use{' '}
      <Link
        href="https://sdl-webapp.apps.gmna.krypton.atmos.gm.com/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: 'inherit', fontWeight: 700, textDecorationColor: 'inherit' }}
      >
        Atmos version of SDL
      </Link>
      .
    </Alert>
  );
};

export default DecommissionBanner;
